import { render } from "./TdPricing.vue?vue&type=template&id=570028aa&scoped=true"
import script from "./TdPricing.vue?vue&type=script&lang=js"
export * from "./TdPricing.vue?vue&type=script&lang=js"

import "./TdPricing.vue?vue&type=style&index=0&id=570028aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570028aa"]])

export default __exports__